import { IsString, IsArray, ValidateNested, IsNumber } from 'class-validator';
import { Type } from 'class-transformer';
import { SpecificationSpecsDto } from '../../specification-specs/specification-specs-dto';

export class Row {
    @IsString()
    time!: string;

    @IsNumber()
    value!: number;
}

export class Variable {
    spec!: SpecificationSpecsDto;

    measurement!: MeasurementResponseDto;
}

export class MeasurementResponseDto {
    @IsString()
    measurement!: string;

    @IsString()
    field!: string;

    @IsArray()
    @ValidateNested({ each: true })
    @Type(() => Row)
    rows!: Row[];
}

type Timestamp = string;

export interface MeasurementResult<F = string> {
    locations: {
        locationId: string;
        devices: {
            macAddress: string;
            assignmentToken: string;
            measurements: {
                measurement: F;
                field: string;
                rows: {
                    time: string;
                    value: number;
                }[];
            }[];
        }[];
    };
}
